export const ENV = {
  EMAILJS: {
    SERVICE_ID: import.meta.env.VITE_EMAILJS_SERVICE_ID || 'service_b8jy3g7',
    TEMPLATE_ID: import.meta.env.VITE_EMAILJS_TEMPLATE_ID || 'template_9fc5nl7',
    PUBLIC_KEY: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'OQKkWa6acQ5BMEvGO',
  },
  RECAPTCHA: {
    SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY || 'placeholder-recaptcha-site-key',
    SECRET_KEY: import.meta.env.VITE_RECAPTCHA_SECRET_KEY || 'placeholder-recaptcha-secret-key',
  }
} as const;

// Type guard with fallbacks for development environment
Object.entries(ENV).forEach(([category, values]) => {
  Object.entries(values).forEach(([key, value]) => {
    if (!value && process.env.NODE_ENV === 'production') {
      console.warn(`Missing environment variable for ${category}.${key} in production environment`);
    }
  });
});